<template>
    <div>
      User activity
      //tbd
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>